/*
 *   File : nominee.js
 *   Author : https://evoqins.com
 *   Description : Nominee card component
 *   Integrations : null
 *   Version : 1
*/

import { Fragment, useRef, useState } from "react";
import { differenceInYears } from "date-fns";

// import components
import { CustomDropdown } from "../Dropdown";
import { CustomDatePicker, CustomPhoneInput, CustomTextArea, CustomTextInput } from "../FormElements";
import { Icon } from "../Icon";
import { useClickOutside } from "../../Helper/helper";
import { PrimaryButton } from "../Buttons";



const NomineeCard = (props) => {

    const pinRef = useRef(null);

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Define the disabled days rule
    const disabledDays = { after: yesterday };

    const IS_MINOR = differenceInYears(new Date(), new Date(props.dob)) < 18;

    const [showDropdown, setShowDropdown] = useState(false);

    useClickOutside(pinRef, () => {
        setShowDropdown(false);
    })

    function _handleDate(date) {
        const [day, month, year] = date.split('-');
        const start_date = new Date(`${year}-${month}-${day}`);
        return start_date
    }

    return (
        <Fragment>
            <div className="pt-4 d-flex align-items-center justify-content-between">
                <h6 className="color-eerie-black e-font-16 e-line-height-32 e-montserrat-semi-bold mb-0">
                    Nominee {props.index + 1}
                </h6>
                {props.total > 1 &&
                    <div >
                        <Icon icon="close"
                            size={20}
                            className='cursor-pointer'
                            onClick={props.removeNominee} />
                    </div>
                }
            </div>
            <div className="row pt-3 position-relative">
                <div className="col-sm-6 pb-4">
                    <CustomTextInput label="Nominee name"
                        postfix="*"
                        value={props.name}
                        error={props.error[0]}
                        placeholder="Name"
                        handleChange={(input_value) => props.handleNominee(input_value, 'name', 0)} />
                </div>
                <div className="col-sm-6 pb-4">
                    <CustomDropdown label="Nominee relationship"
                        postfix="*"
                        options={props.nomineeOptions}
                        value={props.relation}
                        message="No nominee found"
                        error={props.error[1]}
                        placeholder="Relation with nominee"
                        onSelectChange={(select_value) => props.handleNominee(select_value, 'relation', 1)} />
                </div>

            </div>
            <div className="row align-items-center">
                <div className="col-sm-6 pb-4">
                    <CustomDatePicker error={props.error[2]}
                        disabledDays={disabledDays}
                        label="Date of birth"
                        postfix={true}
                        start={props.dob}
                        defaultMonth={props.dob !== "DD-MM-YYYY" ? _handleDate(props.dob) : null}
                        mode="single"
                        selectDate={(date) => {
                            const options = { day: '2-digit', month: '2-digit', year: 'numeric' };

                            const start_date = new Date(date);

                            const formatted_start_date = start_date.toLocaleDateString('en-GB', options).replace(/\//g, '-');
                            props.handleNominee(formatted_start_date, 'dob', 2)
                        }} />
                </div>
                <div className="col-sm-6 col-11 pb-4">
                    <CustomTextInput label="Allocation"
                        postfix="*"
                        value={props.allocation}
                        error={props.error[3]}
                        type="number"
                        placeholder="Allocation %"
                        handleChange={(input_value) => {
                            if (input_value <= 100) {
                                props.handleNominee(input_value, 'allocation', 3)
                            }
                        }} />
                </div>
                {IS_MINOR &&
                    <Fragment>
                        <div className="col-sm-6 pb-4">
                            <CustomTextInput label="Guardian name"
                                postfix="*"
                                value={props.guardianName}
                                error={props.error[4]}
                                placeholder="Name"
                                handleChange={(input_value) => {
                                    props.handleNominee(input_value, 'guardian_name', 4)
                                }} />
                        </div>
                        <div className="col-sm-6 pb-4">
                            <CustomDropdown label="Relation with guardian"
                                postfix="*"
                                options={props.guardianOptions}
                                value={props.guardianRelation}
                                error={props.error[6]}
                                message="No guardian found"
                                placeholder="Select relation"
                                onSelectChange={(select_value) => props.handleNominee(select_value, 'guardian_relation', 6)} />
                        </div>
                        {/* <div className="col-sm-6 col-11 pb-4">
                            <CustomTextInput label="Guardian PAN Number"
                                postfix="*"
                                value={props.guardianPan}
                                error={props.error[5]}
                                placeholder="PAN"
                                inputClass="text-transform-upper"
                                handleChange={(input_value) => props.handleNominee(input_value, 'guardian_pan', 5)} />
                        </div> */}
                    </Fragment>
                }

            </div>

            <div className="row position-relative">
                <div className="col-sm-6 pb-4">
                    <CustomDropdown label="Select identity document"
                        postfix="*"
                        options={props.identityOptions}
                        value={props.document}
                        message="No data found"
                        error={props.error[8]}
                        placeholder="Select identity document"
                        onSelectChange={(select_value) => props.handleNominee(select_value, 'document', 8)} />
                </div>
                <div className="col-sm-6 pb-4">
                    <CustomTextInput label="Identity document number"
                        postfix="*"
                        value={props.documentNumber}
                        error={props.error[7]}
                        type={props.document !== null ? (props.document?.label == "Pan" || props.document?.label == "Passport" || props.document?.label == "Driving licence") ? "text" : "number" : "text"}
                        maxLength={props.document !== null ? props.document?.label == "Pan" ? 10 : props.document?.label == "Passport" ? 9 : props.document?.label == "Driving licence" ? 20 : 4 : undefined}
                        inputClass={props.document !== null && props.document?.label == "Pan" ? "text-transform-upper" : ""}
                        placeholder="Enter number"
                        handleChange={(input_value) => props.handleNominee(input_value, 'document_number', 7)} />
                </div>
            </div>

            <div className="row position-relative">
                <div className="col-sm-6 pb-4">
                    <CustomPhoneInput label="Phone number"
                        postfix="*"
                        placeholder="Enter phone number"
                        value={props.phone}
                        maxLength={10}
                        error={props.error[9]}
                        type="number"
                        handleChange={(input_value) => props.handleNominee(input_value, 'phone', 9)} />
                </div>

                <div className="col-sm-6 pb-4">
                    <CustomTextInput label="Email address"
                        postfix="*"
                        value={props.email}
                        error={props.error[10]}
                        placeholder="Enter email address"
                        handleChange={(input_value) => props.handleNominee(input_value, 'email', 10)} />
                </div>
            </div>

            <div className={`d-flex gap-2 align-items-center cursor-pointer w-max-content`}>
                <Icon
                    icon={props.isSameInvestor[props.index] ? 'checked' : 'unchecked'}
                    size={18}
                    className="d-flex"
                    onClick={() => props.handleSameInvestor(props.index)} />
                <span className={`e-font-14 e-montserrat-medium e-line-height-20px color-eerie-black`}>
                    Same as investor address
                </span>
            </div>

            <div className="row position-relative">
                <div className="col-lg-12 pb-4">
                    <CustomTextArea label="Address line 1"
                        postfix="*"
                        value={props.address}
                        rows={3}
                        error={props.error[11]}
                        placeholder="Enter address"
                        handleChange={(input_value) => props.handleNominee(input_value, 'address', 11)} />
                </div>
            </div>

            

            {/* <div className="pb-4">
                <CustomTextInput label="Pincode"
                    postfix="*"
                    value={props.pincode}
                    error={props.error[15]}
                    placeholder="Enter pincode"
                    handleChange={(input_value) => props.handleNominee(input_value, 'pincode', 15)} />
            </div> */}

            <div className="pb-4">
                {props.loader === false &&
                    <CustomDropdown label="Country"
                        postfix="*"
                        options={props.countryOptions}
                        value={props.country}
                        message="No country found"
                        error={props.error[12]}
                        isSearchable={true}
                        placeholder="Select your Country"
                        onSelectChange={(select_value) => props.handleNominee(select_value, 'country', 12)} />
                }
            </div>

            {props.country !== null && props.country?.value !== 251 ?
                <CustomTextInput label="Pincode"
                    postfix="*"
                    value={props.pincode}
                    error={props.error[15]}
                    placeholder="Enter pincode"
                    handleChange={(input_value) => props.handleNominee(input_value, 'pincode', 15)} />
                :
                <div className="position-relative">
                    <CustomTextInput label="Pincode"
                        value={props.pincode}
                        error={props.error[15]}
                        type="number"
                        placeholder="Enter pincode"
                        postfix="*"
                        handleChange={(input_value) => props.handleNominee(input_value, 'pincode', 15)}
                        onFocus={() => {
                            setShowDropdown(true);
                        }}
                    />
                    {
                        showDropdown === true &&
                        <div className="position-absolute top-80px w-100 box-shadow-black p-3 bg-white z-index-9 border-radius-16px " ref={pinRef}>

                            {props.searchData === true ?
                                <Fragment>
                                    <p className={`mb-0 e-color-eerie-black e-font-14 e-montserrat-regular e-line-height-24`}>
                                        Pin : <span className="e-montserrat-semi-bold">{props.pincode}</span>
                                    </p>
                                    <p className={`mb-0 e-color-eerie-black e-font-14 e-montserrat-regular e-line-height-24`}>
                                        State : <span className="e-montserrat-semi-bold">{props.pinData !== null ? props.pinData.state : "-"}</span>, City: <span className="e-montserrat-semi-bold">{props.pinData !== null ? props.pinData.city : "-"}</span>
                                    </p>

                                    <div className="text-center">
                                        <PrimaryButton label="Continue" className="px-3 mt-3 mx-auto"
                                            onPress={() => {
                                                props.handlePinSubmit(props.index);
                                                setShowDropdown(false);
                                            }} />
                                    </div>
                                </Fragment>
                                :
                                <Fragment>

                                    <p className={`mb-0 e-color-eerie-black e-font-14 e-montserrat-regular e-line-height-24`}>
                                        No data found, please fill the State and City manually
                                    </p>
                                    <div className="text-center">
                                        <PrimaryButton label="Continue" className="px-3 mt-3 mx-auto"
                                            onPress={() => {
                                                props.handlePinSubmit(props.index);
                                                setShowDropdown(false);
                                            }} />
                                    </div>
                                </Fragment>
                            }

                        </div>
                    }
                </div>

            }

            <div className="row pt-4 position-relative">
                <div className="col-sm-6">
                    {props.country !== null && props.country?.value !== 251 ?
                        <CustomTextInput label="State"
                            postfix="*"
                            value={props.state}
                            error={props.error[13]}
                            placeholder="Enter state"
                            handleChange={(input_value) => props.handleNominee(input_value, 'state', 13)} />
                        :
                        <CustomDropdown label="State"
                            postfix="*"
                            options={props.stateOptions}
                            value={props.state}
                            message="No nominee found"
                            error={props.error[13]}
                            isSearchable={true}
                            placeholder="Select state"
                            onSelectChange={(select_value) => props.handleNominee(select_value, 'state', 13)} />

                    }

                </div>
                <div className="col-sm-6">
                    {props.country !== null && props.country?.value !== 251 ?
                        <CustomTextInput label="City"
                            postfix="*"
                            value={props.city}
                            error={props.error[14]}
                            placeholder="Enter city"
                            handleChange={(input_value) => props.handleNominee(input_value, 'city', 14)} />
                        :
                        <div className={`${!props.state ? "opacity-50 pe-none" : ""}`}>
                            <CustomDropdown label="City"
                                postfix="*"
                                options={props.cityOptions}
                                value={props.city}
                                message="No city found"
                                error={props.error[14]}
                                isSearchable={true}
                                placeholder="Select your city"
                                onSelectChange={(select_value) => props.handleNominee(select_value, 'city', 14)} />
                        </div>
                    }
                </div>
            </div>

        </Fragment>
    )
}

export default NomineeCard